<template>
    <b-card class="mb-3">
        <div class="mx-0 mb-4 row">
            <h5>
                {{ $t('menu.createPerson') }}
            </h5>
            <div class="ml-auto">
                <button type="button" class="close" @click="closeForm" :title="$t('general.cancel')">
                    <close-icon title="" />
                </button>
            </div>
        </div>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="create" @change="formChanged">
            <b-form-group :label="$t('person.login')" label-cols-sm="3">
                <b-form-input v-model="formData.login" required></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('general.iin')" label-cols-sm="3">
                <b-form-input v-model="formData.iin" :state="isIinValid"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('person.password')" label-cols-sm="3">
                <b-form-input v-model="formData.password" :state="isValid" required></b-form-input>
                <b-form-text id="inputLiveHelp">
                    {{ $t('person.passwordRequirements') }}
                </b-form-text>
            </b-form-group>
            <b-form-group :label="$t('person.lastname')" label-cols-sm="3">
                <b-form-input v-model="formData.surname" required></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('person.firstname')" label-cols-sm="3">
                <b-form-input v-model="formData.firstName" required></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('person.middlename')" label-cols-sm="3">
                <b-form-input v-model="formData.patronymic"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('person.phone')" label-cols-sm="3">
                <the-mask v-model="formData.phoneNumber" mask="+7 (7##) ###-##-##" placeholder="+7 (7__) ___-__-__" :masked="true" class="form-control" required/>
            </b-form-group>
            <b-form-group :label="$t('person.addressCity')" label-cols-sm="3">
                <multiselect v-model="selectedCity" :options="cities" :close-on-select="true" :hide-selected="true" :show-no-results="false"
                            @search-change="findCity" :internal-search="false"
                            label="name" :placeholder="$t('general.enterValue')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-group v-show="selectedCity" :label="$t('person.addressStreet')" label-cols-sm="3">
                <multiselect v-model="selectedStreet" :options="streets" @input="addressSelected"
                            :close-on-select="true" :hide-selected="true" :showNoResults="false"
                            @search-change="findAddress" :internal-search="false"
                            label="name" :placeholder="$t('general.enterValue')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-group v-show="selectedStreet" :label="$t('person.addressHouse')" label-cols-sm="3">
                <vue-bootstrap-typeahead v-model="formData.addressHouse" :data="houses" :serializer="h => h.name"
                    :min-matching-chars="1" />
            </b-form-group>
            <hr />
            <b-form-group :label="$t('general.role')" label-cols-sm="3">
                <b-form-select v-model="formData.role" required>
                    <option :value="null" disabled>{{ $t('person.selectRole') }}</option>
                    <option v-if="!isAdmin" :value="$appConfig.role.dealer">{{ $t(`role.${$appConfig.role.dealer}`) }}</option>
                    <option v-if="!isAdmin" :value="$appConfig.role.inspector">{{ $t(`role.${$appConfig.role.inspector}`) }}</option>
                    <option v-if="isAdmin" :value="$appConfig.role.admin">{{ $t(`role.${$appConfig.role.admin}`) }}</option>
                    <option v-if="isAdmin" :value="$appConfig.role.operator">{{ $t(`role.${$appConfig.role.operator}`) }}</option>
                </b-form-select>
            </b-form-group>
            <b-form-group v-if="formData.role === $appConfig.role.inspector"
                :label="$t('kkm.inspectionName')" label-cols-sm="3">
                <multiselect v-model="selectedTaxOrg" :options="$store.getters.getTaxOrgs" @input="taxOrgSelected"
                    :close-on-select="true" :hide-selected="true" :showNoResults="false"
                    :custom-label="taxOrgLabel" :placeholder="$t('general.select')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="button" variant="danger" @click="closeForm" :disabled="isDisabled" class="mr-2">
                   <close-icon title="" />&nbsp;{{ $t('general.cancel') }}
                </b-button>
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <plus-icon title="" />&nbsp;{{ $t('general.create') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>

<script>
/* eslint-disable */
import { isIinValid, isPasswordValid } from '../../validators/FormValidators';
import { executeAfterTwoSeconds } from '@/utils/utils';

export default {
    name: 'CreatePersonForm',
    props: {
        toPersonList: Function,
        closeForm: Function
    },
    data () {
        return {
            showAlert: false,
            alert: '',
            formData: {
                login: null,
                password: null,
                firstName: null,
                surname: null,
                patronymic: null,
                phoneNumber: '',
                role: null,
                taxOrganizationId: null,
                unlimitedSessionTimeoutEnabled: false,
                parentId: null,
                addressHouse: null,
                iin: null
            },
            selectedDealer: null,
            selectedTaxOrg: null,
            selectedCity: null,
            selectedStreet: null,
            cities: [],
            dealers: [],
            taxInspections: [],
            streets: [],
            houses: []
        }
    },
    computed: {
        isDisabled: function () {
            return this.$store.getters.isLoading
        },
        isAdmin: function () {
            return this.$store.getters.getUserRole === this.$appConfig.role.admin
        },
        isValid: function () {
            if (this.formData.password === null) {
                return null;
            }
           
           return isPasswordValid(this.formData.password);
        },
        isIinValid: function() {
            return this.formData.iin != null 
                ? isIinValid(this.formData.iin)
                : null;
        } 
    },
    methods: {
        formChanged: function () {
            this.hideAlert()
        },
        taxOrgSelected: function (value) {
            this.formData.taxOrganizationId = value ? value.id : null
        },
        taxOrgLabel: function ({ code, name }) {
            return `${code} - ${name}`
        },
        findCity: executeAfterTwoSeconds(function(query) {
            if (query.length < 3)
                return;

            const request = {
                data: { address: query },
                onSuccess: cities => this.cities = cities,
                onError: this.displayAlert 
            };

            this.$request.getCities(this, request);
        }),
        findAddress: executeAfterTwoSeconds(function (query) {
            if (query.length < 3)
                return;

            const request = {
                data: { 
                    address: query,
                    parentId: this.selectedCity.pointId 
                },
                onSuccess: streets => this.streets = streets,
                onError: this.displayAlert 
            };

            this.$request.getStreets(this, request);
        }),
        addressSelected: executeAfterTwoSeconds(function (house) {
            this.formData.parentId = house != null 
                ? house.id 
                : null;
            
            const request = {
                data: { parentId: this.formData.parentId },
                onSuccess: houses => this.houses = houses,
                onError: this.displayAlert 
            };

            this.$request.getHouses(this, request);
        }),
        create: function () {
            this.hideAlert();

            if (!this.isValid) {
                this.displayAlert('passwordNotValid');
                return;
            }

            if (this.formData.phoneNumber) {
                this.formData.phoneNumber = this.formData.phoneNumber.replace(/\D/g, '');
            }

            if (this.formData.role === this.$appConfig.role.inspector && this.formData.taxOrganizationId == null) {
                this.displayAlert('taxorgIdMustBeSet');
                return;
            }

            const onSuccess = result => {
                this.toPersonList({ id: result.value });
                this.closeForm();
            };

            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.person.create,
                this.formData, 
                onSuccess,
                this.displayAlert);
        },
        hideAlert: function () {
            this.showAlert = false
            this.alert = ''
        },
        displayAlert: function(errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        }
    }
}
</script>
